import { Injectable } from '@angular/core';

export enum State {
  Menu = 'MENU',
  ProductsMenu = 'PRODUCTS_MENU',
  ServicesMenu = 'SERVICES_MENU',
  AreaOfUseMenu = 'AREA_OF_USE_MENU',
  SubMenu = 'SUB_MENU',
  ChangeCustomer = 'CHANGE_CUSTOMER',
  ProductsSubMenu = 'PRODUCTS_SUB_MENU',
  AreaOfUseSubMenu = 'AREA_OF_USE_SUB_MENU',
  MyAssortmentProductsSubMenu = 'MY_ASSORTMENT_PRODUCTS_SUB_MENU',
  CampaignsSubMenu = 'CAMPAIGNS_SUB_MENU',
  AddonSubMenu = 'ADDON_SUB_MENU',
}

interface PrevItem {
  title: string;
  subItems: Array<any>;
  state: State;
}

/**
 * A service to handle mobile navigation state
 */
@Injectable({
  providedIn: 'root',
})
export class MobileNavigationStateService {
  private state: State = State.Menu;
  private drawerTitle = '';
  private prevItems: PrevItem[] = [];

  constructor() {}

  public get currentState(): State {
    return this.state;
  }

  public setCurrentState(newState: State) {
    this.state = newState;
  }

  public get getDrawerTitle(): string {
    return this.drawerTitle;
  }

  public setDrawerTitle(drawerTitle: string) {
    this.drawerTitle = drawerTitle;
  }

  public setPrevItems(prevs: PrevItem[]) {
    this.prevItems = prevs;
  }

  public addPrevItem(state: PrevItem) {
    this.prevItems.push(state);
  }

  public get getPrevItems(): PrevItem[] {
    return this.prevItems;
  }
}
